import Component, { getWidgetServerSideProps } from 'page-components/global/widget/[type]';
import { propsWithI18NSSR } from 'util/propsWithI18n';

export default Component;
export const getServerSideProps = propsWithI18NSSR(getWidgetServerSideProps);
